import styled, { css } from 'styled-components'
import perMeterCalc from '../../utils/perMeterCalc'
import {
  getProp,
  getPropOrTheme,
  scaleBackgroundWidth,
  scaleBackgroundHeight,
  scalePositionX,
  scalePositionY,
} from './themeHelpers'

export const Product = styled.div`
  width: ${getProp('w', { suffix: 'px' }, 'auto')};
  height: ${getProp('h', { suffix: 'px' }, 'auto')};
  overflow: hidden;

  background: ${getPropOrTheme(
    'selectedImage',
    {
      prefix: 'url(',
      suffix: ') no-repeat',
    },
    'theme.colors.secondaryLight'
  )};

  background-size: ${scaleBackgroundWidth}px ${scaleBackgroundHeight}px;
  background-position-x: ${scalePositionX}px;
  background-position-y: ${scalePositionY}px;

  box-shadow: ${props => (props.isSelected ? `0px 0px 15px #00ffe5` : props.isDragSelected ? `0px 0px 15px #18d0bede` : 'none')};

  ${props => props.borderType === 'noframe' && noframe()};
  ${props => props.borderType === 'frame' && frame(props)};
  ${props => props.borderType === 'passe-partout' && passePartout(props)};
  ${props => props.borderType === 'passe-partout-deluxe' && passePartout(props, true)};
`

const noframe = () => css`
  border: none;
`
const frame = ({ borderColor = '#707070', perMeter, borderWidth }) => css`
  border: ${perMeterCalc(borderWidth, perMeter)}px solid ${borderColor};
`
const passePartout = ({ borderColor = '#707070', perMeter, borderWidth }, deluxe = false) => css`
  border: ${perMeterCalc(borderWidth, perMeter)}px solid ${borderColor};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: ${perMeterCalc(borderWidth, perMeter*2)}px solid ${deluxe? '#e6e6e6':'white'};
  }
`



// WEBPACK FOOTER //
// ./src/components/PreviewProduct/theme.js